module.exports = __webpack_public_path__ + "static/media/funan_1.5228878d.jpg";